import React, { PropsWithChildren } from "react";

export const ShareIcon: React.FC<PropsWithChildren<React.SVGProps<SVGSVGElement>>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.163 17.63C10.9135 17.63 5.00414 26.996 4.99902 36.83V38.054C9.246 32.9379 16.3657 29.82 22.163 29.82V36.274C22.1632 37.2105 22.6985 38.0644 23.5412 38.4728C24.3839 38.8812 25.3859 38.7721 26.121 38.192L39.9201 25.574C40.4875 25.1269 40.8186 24.4444 40.8186 23.722C40.8186 22.9996 40.4875 22.3171 39.9201 21.87L26.121 9.25201C25.3859 8.6719 24.3839 8.56285 23.5412 8.97121C22.6985 9.37958 22.1632 10.2336 22.163 11.17V17.63Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
